import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { differenceInYears, format, parseISO } from 'date-fns'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function calculateAge(dob: string | Date): number {
  const birthDate = typeof dob === 'string' ? parseISO(dob) : dob
  return differenceInYears(new Date(), birthDate)
}

export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? parseISO(date) : date
  return format(d, 'dd/MM/yyyy')
}

export function generateRegistrationId(sequence: number): string {
  const year = new Date().getFullYear()
  const padded = String(sequence).padStart(6, '0')
  return `DATA-${year}-${padded}`
}

export function getAgeGroup(age: number): string {
  if (age <= 18) return '0-18'
  if (age <= 30) return '19-30'
  if (age <= 45) return '31-45'
  if (age <= 60) return '46-60'
  return '60+'
}

export function parseIndianMobile(mobile: string): string {
  return mobile.replace(/^\+91/, '').replace(/[\s-]/g, '').trim()
}

export function formatMobile(mobile: string): string {
  const clean = parseIndianMobile(mobile)
  if (clean.length !== 10) return mobile
  return `+91 ${clean.slice(0, 5)} ${clean.slice(5)}`
}
